<template>
    <div>
        <div class="flex-parent-center tw-flex tw-flex-col">
            <div class="author tw-my-10 tw-flex tw-rounded">
                <img :src="author.image" class="tw-rounded-full tw-object-cover">
                <div class="tw-flex-1 tw-ml-6">
                    <h3 class="tw-text-3xl tw-my-2 tw-font-semibold tw-text-gray-700" v-html="author.name"></h3>
                    <span class="tw-text-gray-300 tw-text-sm" v-if="author.function" v-html="author.function"></span>
                    <p class="tw-text-gray-500 tw-leading-relaxed tw-mt-4 tw-whitespace-pre-line" v-html="author.description"></p>
                </div>
            </div>
        </div>
        <div class="tw-bg-gray-100" v-if="author.product_count > 1">
            <div class="flex-parent-center tw-flex tw-flex-col">
                <h4 class="tw-text-gray-700 tw-text-xl tw-font-bold tw-mt-12">{{ $t('general.more') }} {{ $t('membership.products').toLowerCase() }} {{ $t('general.by') }} {{ author.name }}</h4>
                <div class="flex-1 flex-full-width tw-px-0">
                    <courses-cards :courses="author_courses" :loaded="loaded" :skeletonCount="3"></courses-cards>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import CoursesCards from './CoursesCards.vue'
    import Global from '../../mixins/Global.js'
    import CourseV2 from '../../lib/models/Course.js'

    export default {
        name: 'Author',

        mixins: [Global],

        components: {
            CoursesCards,
        },

        props: ['author', 'courseId'],

        data() {
            return {
                author_products: false,
                loaded: false,
            }
        },

        computed: {
            author_courses(){
                const courses = CourseV2.query().where((course) => {
                    if(course.author){
                        return course.author.id === this.author.id && this.courseId !== course.id
                    } else {
                        return course.author_id === this.author.id && this.courseId !== course.id
                    }
                }).limit(3).get();

                this.loaded = true;
                return courses;
            }
        },

        mounted() {
            if(this.author.product_count > 1) {
                CourseV2.api().fetchCoursesByAuthorId(this.author.id);
            }
        },
    }
</script>

<style lang="scss" scoped>
    .flex-parent-center {
        max-width: 900px;
        padding-left: 15px;
        padding-right: 15px;
    }

    .author {
        img {
            width: 55px;
            height: 55px;

            @screen md {
                width: 100px;
                height: 100px;
            }
        }
    }
</style>
